import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Image from '../../misc/Image';
import ImageInfo from '../../misc/ImageInfo';

import { getPhotoVariant } from '../../../utils/common';
import { SOCIAL_MEDIA, THUMBNAIL } from '../../../utils/variables';

class MediaListItem extends React.Component {
  constructor(props) {
    super(props);
  }

  _getPhotoVariant = () => {
    const { isAccountEventPage, item } = this.props;
    // According to the backend team, we can't assume that the object which describes a
    // specific variant will always be found at the same index in the array.

    // if (isAccountEventPage) {
    //   const socialMedia = getPhotoVariant(item.variants, SOCIAL_MEDIA);
    //   if (socialMedia) {
    //     return socialMedia;
    //   }
    // }

    // If none of the previous variants were found return the 'thumbnail' variant
    return getPhotoVariant(item.variants, THUMBNAIL);
  };

  // _getPhotoVariantDebug = () => {
  //   const currentBackendImageUrl = 'https://www.sportograf.com/gallery/';
  //   const regEx = /http.+\/thumbnail\//gi;
  //   return {
  //     url: this.props.item.variants[2].url.replace(regEx, currentBackendImageUrl)
  //   };
  // }

  render() {
    const { item, intl, onShowPreview } = this.props;

    const photoVariant = this._getPhotoVariant();

    return (
      <div className="medialist-item-container" onClick={() => onShowPreview(item.id)}>
        <Image
          src={photoVariant.url}
          imgHasFullWidth={true}
          bottomLeftElement={
            <ImageInfo
              label={intl.formatTime(new Date(item.shotDate), {
                timeZone: 'UTC',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              })}
            />
          }
        />
      </div>
    );
  }
}

MediaListItem.propTypes = {
  isAccountEventPage: PropTypes.bool,
  item: PropTypes.object,
  intl: PropTypes.object,
  onShowPreview: PropTypes.func,
};

export { MediaListItem };

export default createFragmentContainer(injectIntl(MediaListItem), {
  item: graphql`
    fragment MediaListItem_item on Media {
      id
      sgId
      name
      shotDate
      variants {
        name
        url
      }
    }
  `,
});
